import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

type GraphLayoutProps = {
	children: React.ReactNode;
};

export const GraphLayout = ({ children }: GraphLayoutProps) => (
	<Box xcss={layoutStyles}>{children}</Box>
);

const layoutStyles = xcss({
	display: 'grid',
	gridTemplateColumns: 'minmax(0, 1fr) auto',
	height: '100%',
	overflow: 'hidden',
	borderRadius: 'radius.medium',
	backgroundColor: 'elevation.surface.raised',
	minHeight: '80px',
});
